var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-section-select",class:{ 'button-section-select--active': _vm.isActive },on:{"click":function($event){return _vm.$emit('click', _vm.id)}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }